import { render, staticRenderFns } from "./ifizxlaw.vue?vue&type=template&id=66aaa957&scoped=true&"
import script from "./ifizxlaw.vue?vue&type=script&lang=js&"
export * from "./ifizxlaw.vue?vue&type=script&lang=js&"
import style0 from "./ifizxlaw.vue?vue&type=style&index=0&id=66aaa957&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66aaa957",
  null
  
)

export default component.exports